<template>
    <div>
        <div class="filter-places" v-if="countries && countries.length > 0">
            <div class="title">Populære land:</div>
            <ul>
                <li
                    :class="
                        !['countryPlace', 'travelTypeCountryPlace'].includes(pageType) && 'active'
                    "
                    v-if="entry?.slug != travelType"
                >
                    <a
                        :href="
                            buildUrl(
                                travelType
                                    ? '/' + travelType + '/' + entry.uri.split('/')[0]
                                    : '/' + entry.uri.split('/')[0]
                            )
                        "
                        rel="nofollow"
                    >
                        Alle
                    </a>
                </li>

                <li
                    v-for="(country, i) in countries"
                    :class="[
                        'checkbox',
                        i > 3 && countryCollapsed && 'hidden',
                        country.slug == entry.slug && 'active',
                    ]"
                >
                    <a
                        :href="
                            buildUrl(
                                travelType ? '/' + travelType + '/' + country.uri : country.url
                            )
                        "
                        v-text="country.title"
                        rel="nofollow"
                    />
                </li>
            </ul>

            <a
                v-if="countries.length > 4"
                href="javascript:"
                class="more"
                @click="toggleCountryCollapsed"
            >
                {{ countryCollapsed ? '+ Vis flere' : '- Vis mindre' }}
            </a>
        </div>
        <div class="filter-places" v-if="places && places.length > 0">
            <div class="title">Populære steder:</div>
            <ul>
                <li
                    :class="
                        !['countryPlace', 'travelTypeCountryPlace'].includes(pageType) && 'active'
                    "
                    v-if="entry?.slug != travelType"
                >
                    <a
                        :href="
                            buildUrl(
                                travelType
                                    ? '/' + travelType + '/' + entry.uri.split('/')[0]
                                    : '/' + entry.uri.split('/')[0]
                            )
                        "
                        rel="nofollow"
                    >
                        Alle
                    </a>
                </li>
                <li
                    v-for="(place, i) in places"
                    :class="[
                        'checkbox',
                        i > 3 && placeCollapsed && 'hidden',
                        place.slug == entry.slug && 'active',
                    ]"
                >
                    <a
                        :href="
                            buildUrl(travelType ? '/' + travelType + '/' + place.uri : place.url)
                        "
                        v-text="place.title"
                        rel="nofollow"
                    />
                </li>
            </ul>

            <a
                v-if="places.length > 4"
                href="javascript:"
                class="more"
                @click="togglePlaceCollapsed"
            >
                {{ placeCollapsed ? '+ Vis flere' : '- Vis mindre' }}
            </a>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { ref } from 'vue'

    defineProps({
        entry: {
            required: true,
        },
        pageType: {
            required: true,
        },
        places: {
            required: false,
        },
        countries: {
            required: false,
        },
        travelType: {
            required: false,
        },
    })

    const countryCollapsed = ref(true)
    const placeCollapsed = ref(true)
    const params = ref(window.location.search)
    const buildUrl = (url) => url + params.value

    const togglePlaceCollapsed = () => (placeCollapsed.value = !placeCollapsed.value)
    const toggleCountryCollapsed = () => (countryCollapsed.value = !countryCollapsed.value)
</script>
